export default [
  {
    path: '/b2bhub/operacoes/budget',
    name: 'budget',
    component: () => import('@/views/app/budget/budgets.vue'),
    meta: {
      pageTitle: 'Budget',
      action: 'manage',
      resource: 'Budget',
    },
  },
  {
    path: '/b2bhub/operacoes/budget-alocacao',
    name: 'budget-alocacao',
    component: () => import('@/views/app/budget/AlocacaoBudget.vue'),
    meta: {
      pageTitle: 'Alocação de Budget',
      action: 'alocar',
      resource: 'BudgetAlocacao',
    },
  },
  {
    path: '/b2bhub/operacoes/budget-dashboard',
    name: 'budget-dashboard',
    component: () => import('@/views/app/budget/dashboardBudget.vue'),
    meta: {
      pageTitle: 'Dashboard de Budget',
      action: 'read',
      resource: 'BudgetDashboard',
    },
  },
  {
    path: '/b2bhub/operacoes/budget/:id',
    name: 'budget-detalhes',
    component: () => import('@/views/app/budget/DetalhesBudget.vue'),
    meta: {
      pageTitle: 'Detalhes do Budget',
      navActiveLink: 'budget',
      action: 'manage',
      resource: 'Budget',
    },
  },
];
